class SolicitacaoCadastro {
  constructor() {
    this.id = null

    this.numDocContribuinte = ''
    this.nomeContribuinte = ''
    this.tipoLogra = ''
    this.logradouro = ''
    this.numero = ''
    this.complemento = ''
    this.cep = ''
    this.bairro = ''
    this.cidade = ''
    this.estado = ''
    this.email = ''
    this.contato = ''
    this.dataSolicitacao = ''
    this.dataDeferimento = ''
    this.observacao = ''
    this.version = ''
    this.nomeAcesso = ''
    this.inscricaoMunicipal = ''
    this.dataVigenciaInicial = ''
    this.dataVigenciaFinal = ''
    this.tipoSistema = ''
    this.contatocelular = ''

    this.idContribuinte = null
    this.idCliente = null
    this.idPessoaTipo = null
    this.idBolDeclara = null
    this.idFichaRespostaPai = null
    this.idFluxoInstanciaAtividade = null
    this.idStatusSolicitacao = null
    
    this.senha = ''
    this.senhaConfirma = ''
    this.tipoPessoa = ''

    this.addSocioVinculo = null;
  }
}

export default SolicitacaoCadastro
